import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useState } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from './utils';
/** @internal */

/**
 * An HOC that injects a `composing` prop into the wrapped component that
 * indicates whether IME composition is in progress.
 */
const IMEAware = Component => {
  const IMEAwareComponent = /*#__PURE__*/forwardRef((props, ref) => {
    const handlers = {};
    /* eslint-disable react-hooks/rules-of-hooks */

    const [composing, setComposing] = useState(false);
    ['onCompositionStart', 'onCompositionEnd'].forEach(handlerKey => {
      const receivedHandlerRef = useRef();
      const handlerRef = useRef();

      if (!handlerRef.current || receivedHandlerRef.current !== props[handlerKey]) {
        receivedHandlerRef.current = props[handlerKey];

        handlerRef.current = evt => {
          setComposing(handlerKey === 'onCompositionStart');

          if (props[handlerKey]) {
            // @ts-expect-error props[handlerKey] is callable
            props[handlerKey](evt);
          }
        };
      }

      handlers[handlerKey] = handlerRef.current;
    });
    /* eslint-enable react-hooks/rules-of-hooks */

    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {}, handlers, {
      composing: composing,
      ref: ref
    }));
  });
  IMEAwareComponent.displayName = `IMEAware(${getComponentName(Component)})`; // @ts-expect-error Ignore PropTypes type mismatch

  IMEAwareComponent.propTypes = Object.assign({}, Component.propTypes); // @ts-expect-error Ignore PropTypes type mismatch

  delete IMEAwareComponent.propTypes.composing; // @ts-expect-error Ignore PropTypes type mismatch

  IMEAwareComponent.defaultProps = Component.defaultProps;
  attachWrappedComponent(IMEAwareComponent, Component);
  return IMEAwareComponent;
};

export default IMEAware;